var map = {
	"./1.png": 20362,
	"./10.png": 85616,
	"./11.png": 91865,
	"./12.png": 25282,
	"./13.png": 99435,
	"./14.png": 49524,
	"./15.png": 70653,
	"./16.png": 89446,
	"./17.png": 70991,
	"./18.png": 79832,
	"./19.png": 17313,
	"./2.png": 34593,
	"./20.png": 34805,
	"./21.png": 65708,
	"./22.png": 85767,
	"./23.png": 67454,
	"./24.png": 8465,
	"./25.png": 10600,
	"./26.png": 95875,
	"./27.png": 78298,
	"./28.png": 78157,
	"./29.png": 38212,
	"./3.png": 13464,
	"./30.png": 64906,
	"./31.png": 20115,
	"./4.png": 62455,
	"./5.png": 16878,
	"./6.png": 87237,
	"./7.png": 4348,
	"./8.png": 13835,
	"./9.png": 92706,
	"./default.png": 41308,
	"./legion_knight.png": 50997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26741;